import FooterStyled from "./Footer.styled";

const Footer = () => {
    return (
        <FooterStyled>
            <footer>
                <h2 >Movie App</h2>
                <p>Created by <a className="linkedin" href="https://www.linkedin.com/in/annisa-maulida-3549241a9/">anseyo</a></p>
            </footer>
        </FooterStyled>
    )
    }
export default Footer;